import { render, staticRenderFns } from "./ProfileImageModal.vue?vue&type=template&id=77b48d3e&"
import script from "./ProfileImageModal.vue?vue&type=script&lang=ts&"
export * from "./ProfileImageModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports